export default __webpack_public_path__ + "fc1666f57b8ce2f9badd5a996c068c77.png";